const common = {
  common: {
    loading: "載入中...",
    error: "發生錯誤",
    success: "成功",
    cancel: "取消",
    confirm: "確認",
    submit: "提交",
    save: "儲存",
    edit: "編輯",
    delete: "刪除",
    search: "搜尋",
    filter: "篩選",
    moreInfo: "更多資訊",
    lessInfo: "收起資訊",
    previous: "上一頁",
    next: "下一頁",
    back: "返回",
    create: "建立",
    retry: "重試",
  },

  general: {
    back: "返回",
    cancel: "取消",
    close: "關閉",
    confirm: "確認",
    error: "錯誤",
    loadingText: "載入中...",
    noSearchResults: "沒有符合搜尋條件的結果",
    retry: "重試",
    search: "搜尋",
    unknown: "未知",
  },
};

export default common;
